/**
 * Generates a random integer between the specified min and max, inclusive.
 *
 * @param {number} min - The minimum value, inclusive.
 * @param {number} max - The maximum value, inclusive.
 * @returns {number} A random integer between min and max, inclusive.
 */
export const getRandomIntInclusive = (min, max) =>
   Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min) + 1)) +
   Math.ceil(min);

/**
 * Converts a string to an integer.
 *
 * @param {string} str - The input string to be converted.
 * @returns {number} The parsed integer or 0 if the input is not a valid number.
 */
export const toInt = (str) => (isNaN(parseInt(str)) ? 0 : parseInt(str));

/**
 * Converts a string to a floating-point number.
 *
 * @param {string} str - The input string to be converted.
 * @returns {number} The parsed floating-point number or 0 if the input is not a valid number.
 */
export const toFloat = (str) => (isNaN(parseFloat(str)) ? 0 : parseFloat(str));

/**
 * Parses a string value to a float, but preserves incomplete decimal strings 
 * (like ending with a dot or containing a dot and ending with zero) to support 
 * active user typing in form inputs.
 *
 * @param {string|number} val - The input value to parse.
 * @returns {number|string} The parsed float or the input string if incomplete/typing.
 */
export const parseFloatValue = (val) => {
  if (val === "" || val === undefined || val === null) {
    return 0;
  }
  if (val === "-" || val.endsWith(".") || (val.indexOf(".") !== -1 && val.endsWith("0"))) {
    return val;
  }
  const parsed = parseFloat(val);
  return isNaN(parsed) ? 0 : parsed;
};
